export const IconClock = ({ className }) => (
  <svg
    className={className}
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='10.9009' cy='10.7896' r='8' fill='#752FB9' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2813 10.8295h2.2857a.762.762 0 010 1.5239h-2.8096c-.5522 0-1-.4478-1-1V7.7819a.762.762 0 011.5239 0v3.0476z'
      fill='#fff'
    />
  </svg>
);

export const IconAcademicCap = ({ className }) => (
  <svg
    className={className}
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.1047 11.4136v2.3416c0 .6084.3333 1.175.8666 1.4667l4.1667 2.275c.5.275 1.1.275 1.6 0l4.1667-2.275c.5333-.2917.8666-.8583.8666-1.4667v-2.3416l-5.0333 2.75c-.5.275-1.1.275-1.6 0l-5.0333-2.75zm5.0333-8.05L3.113 7.1969c-.575.3167-.575 1.15 0 1.4667l7.025 3.8333c.5.275 1.1.275 1.6 0l7.1455-3.8983a.7443.7443 0 00.0021-1.3056L11.738 3.3636a1.7 1.7 0 00-1.6 0z'
      fill='#752FB9'
    />
  </svg>
);

export const IconCompleted = ({ className }) => (
  <svg
    className={className}
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.938 2.4302c-2.0801 0-3.8559 1.3411-4.5188 3.2H5.338c-.88 0-1.6.72-1.6 1.6v6.4c0 .88.72 1.6 1.6 1.6h11.2c.88 0 1.6-.72 1.6-1.6v-2.836c.9788-.88 1.6-2.151 1.6-3.564 0-2.6415-2.1585-4.8-4.8-4.8zm0 1.6c.8031 0 1.5245.3016 2.0844.7843L14.938 6.899l-.2344-.2344a.7997.7997 0 00-.8795-.1866.8002.8002 0 00-.2517 1.3179l1.3656 1.3656 3.0047-3.0047c.1192.3366.1953.6943.1953 1.0735a3.188 3.188 0 01-3.2 3.2 3.188 3.188 0 01-3.2-3.2 3.188 3.188 0 013.2-3.2zm-11.2 12.8c-.4416 0-.8.3584-.8.8 0 .4416.3584.8.8.8h14.4c.4416 0 .8-.3584.8-.8 0-.4416-.3584-.8-.8-.8h-14.4z'
      fill='#752FB9'
    />
  </svg>
);

export default IconClock;
